import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import Grid from "@mui/material/Grid";

import {greyishBlue500} from "assets/jss/main";

import {SyliusCandidatesContext} from "views/shippingMethods/context/SyliusCandidatesContext";

// What the last fetch did, and what the push would change on Sylius: to settle before turning the push on.
function SyliusFetchReport(props) {
    const {fetchReport} = useContext(SyliusCandidatesContext);

    if (!fetchReport) {
        return null;
    }

    const {candidates = [], seeded = [], drifts = [], notOnEshop = []} = fetchReport;

    return (
        <Grid item xs={12} sx={{padding: '8px 0 16px', fontSize: '14px'}}>
            <div>
                <FormattedMessage
                    id={'shippingMethods.sylius.report.summary'}
                    values={{missing: candidates.length, seeded: seeded.length}}
                />
            </div>
            {notOnEshop.length > 0 && (
                <div style={{color: greyishBlue500}}>
                    <FormattedMessage id={'shippingMethods.sylius.report.notOnEshop'} values={{codes: notOnEshop.join(', ')}}/>
                </div>
            )}
            {drifts.length > 0 && (
                <>
                    <div style={{marginTop: '8px', fontWeight: 600}}>
                        <FormattedMessage id={'shippingMethods.sylius.report.drifts'}/>
                    </div>
                    <table style={{borderSpacing: '16px 2px'}}>
                        <thead>
                            <tr>
                                <th align={'left'}><FormattedMessage id={'shippingMethods.header.sylius-code'}/></th>
                                <th align={'left'}><FormattedMessage id={'shippingMethods.sylius.report.field'}/></th>
                                <th align={'left'}><FormattedMessage id={'shippingMethods.sylius.report.marketplace'}/></th>
                                <th align={'left'}>Sylius</th>
                            </tr>
                        </thead>
                        <tbody>
                            {drifts.map(drift => (
                                <tr key={`${drift.code}-${drift.field}`}>
                                    <td>{drift.code}</td>
                                    <td><FormattedMessage id={`shippingMethods.sylius.report.field.${drift.field}`} defaultMessage={drift.field}/></td>
                                    <td><DriftValue value={drift.marketplace}/></td>
                                    <td><DriftValue value={drift.sylius}/></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}
        </Grid>
    );
}

// React renders no boolean (active, returnOnly): shown as yes/no; a missing value as a dash.
function DriftValue({value}) {
    if (typeof value === 'boolean') {
        return <FormattedMessage id={value ? 'yes' : 'no'}/>;
    }

    return value ?? '-';
}

export default SyliusFetchReport;
